export default {
    namespaced: true,
    state: {
        humanSystemTypes: null,
        loadingList: false
    },
    getters: {
        humanSystemTypes: state => state.humanSystemTypes,
        loadingList: state => state.loadingList
    },
    mutations: {
        SET_HUMAN_SYSTEM_TYPES: (state, data) => {
            state.humanSystemTypes = data
        },
        START_LOADING_LIST: state => {
            state.loadingList = true
        },
        END_LOADING_LIST: state => {
            state.loadingList = false
        },
    },
    actions: {
        getComplexListData: async function(context, payload) {
            return new Promise((resolve, reject) => {
                this.$api.complexExercises.getList(payload)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(response => {
                        reject(response)
                    })
            })
        },
        getComplexData: async function(context, id) {
            return new Promise((resolve, reject) => {
                this.$api.complexExercises.getComplex(id)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(response => {
                        reject(response)
                    })
            })
        },
        deleteComplex: async function(context, id) {
            return new Promise((resolve, reject) => {
                this.$api.complexExercises.delete(id)
                    .then(() => {
                        resolve()
                    })
                    .catch(response => {
                        reject(response)
                    })
            })
        },
        sendComplex: async function(context, payload) {
            let method = !payload.id ? 'create' : 'edit'

            return new Promise((resolve, reject) => {
                this.$api.complexExercises[method](payload)
                    .then(() => {
                        resolve()
                    })
                    .catch(response => {
                        reject(response)
                    })
            })
        },
        getHumanSystemTypes: async function({commit}) {
            return new Promise((resolve, reject) => {
                this.$api.complexExercises.getHumanSystemTypes()
                    .then((response) => {
                        commit('SET_HUMAN_SYSTEM_TYPES', response.data)
                        resolve()
                    })
                    .catch(response => {
                        reject(response)
                    })
            })
        },
        startLoadingList: async function({commit}) {
            commit('START_LOADING_LIST')
        },
        endLoadingList: async function({commit}) {
            commit('END_LOADING_LIST')
        }
    }
}
